import {getCurrentInstance} from "vue";
import {usePage} from "@inertiajs/inertia-vue3";

export function useHelpers() {
    const vm = getCurrentInstance();
    return vm.appContext.config.globalProperties.$helpers;
}

export function useTenantTextRules() {
    const page = usePage();

    const resolveTextRule = (termKey, fallback, context) => {
        const rules = page.props.value?.app?.textRules || {};
        const rule = rules[termKey];

        const isEnabled = rule?.enabled === true
            || rule?.enabled === 1
            || rule?.enabled === '1'
            || rule?.enabled === 'true';

        if (!rule || !isEnabled) {
            return fallback;
        }

        const replacement = `${rule.replacement || ''}`.trim();
        if (replacement === '') {
            return fallback;
        }

        const applyMode = `${rule.apply_mode || 'all'}`.trim();
        const includedContexts = Array.isArray(rule.included_contexts) ? rule.included_contexts : [];
        const excludedContexts = Array.isArray(rule.excluded_contexts) ? rule.excluded_contexts : [];

        if (applyMode === 'selected') {
            return includedContexts.includes(context) ? replacement : fallback;
        }

        return excludedContexts.includes(context) ? fallback : replacement;
    };

    return { resolveTextRule };
}

export function useTenantButtonVisibility() {
    const page = usePage();

    const getButtonVisibility = (buttonKey, defaultValue = null) => {
        const buttons = page.props.value?.app?.buttonVisibility || {};
        const value = buttons?.[buttonKey];

        return value === null || value === undefined ? defaultValue : Boolean(value);
    };

    const isButtonVisible = (buttonKey) => {
        return getButtonVisibility(buttonKey, true) !== false;
    };

    const isButtonEnabled = (buttonKey, defaultValue = false) => {
        return getButtonVisibility(buttonKey, defaultValue) === true;
    };

    return { isButtonVisible, isButtonEnabled, getButtonVisibility };
}
